<!-- https://www.figma.com/file/hZ14djvbx5qYuIJwSU7moW/%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B-%F0%9F%94%A5?node-id=6912%3A143724&t=dNYsiiXrAXDAdrTs-1 -->
<template>
  <form
    ref="form"
    class="ads-contact-form"
    @submit="onSubmit"
  >
    <div
      v-if="state === 'success'"
      class="ads-contact-form__success"
    >
      <div class="ads-contact-form__success-title">Спасибо!</div>
      <div class="ads-contact-form__success-description">Мы ответим быстро, обещаем.</div>
    </div>

    <div
      v-else
      class="ads-contact-form__content"
    >
      <div class="ads-contact-form__title">Напишите нам</div>

      <div class="ads-contact-form__field ads-contact-form__field--name field">
        <TextAreaCustom
          :id="fieldName.id"
          :placeholder="fieldName.placeholder"
          :rows="fieldNameRows"
          :value="fieldName.value"
          @on-input="(onInput(), (fieldName.value = $event))"
        />
      </div>

      <div class="ads-contact-form__field ads-contact-form__field--target field">
        <TextAreaCustom
          :id="fieldTarget.id"
          :value="fieldTarget.value"
          :placeholder="fieldTarget.placeholder"
          :maxlength="fieldTarget.maxLength"
          :rows="fieldTargetRows"
          @on-input="(onInput(), (fieldTarget.value = $event))"
        />
        <div class="field__footer">
          <div class="field__counter">
            <span>{{ parsedFieldNotTags(fieldTarget).length }}</span>
            <span>/ {{ fieldTarget.maxLength }}</span>
          </div>
        </div>
      </div>

      <div class="ads-contact-form__contact-title">Как с вами связаться?</div>

      <div class="ads-contact-form__radio-group">
        <InputRadioGroup
          :value="contactType"
          :options="contactTypes"
          name="contactType"
          @on-input="(onInput(), (contactType = $event))"
        />
      </div>

      <div class="ads-contact-form__contact">
        <TextInput
          v-if="contactType === 'email'"
          :id="fieldEmail.id"
          :value="fieldEmail.value"
          :placeholder="fieldEmail.placeholder"
          :state="fieldEmail.state"
          @on-focus="onFocusField(fieldEmail)"
          @on-blur="onBlurField(fieldEmail)"
          @on-input="(onInput(), (fieldEmail.value = $event))"
        >
          <div
            v-if="fieldEmail.isFocus || fieldEmail.isVerify"
            class="field__state"
          >
            <div
              :class="verifyEmailClass"
              class="verify"
            />
          </div>
        </TextInput>

        <TextInput
          v-if="contactType === 'phone'"
          :id="fieldPhone.id"
          :value="fieldPhone.value"
          class="number-input"
          :placeholder="fieldPhone.placeholder"
          :state="fieldPhone.state"
          :masked="fieldPhone.mask"
          type="tel"
          @on-focus="onFocusField(fieldPhone)"
          @on-blur="onBlurField(fieldPhone)"
          @on-input="(onInput(), (fieldPhone.value = $event))"
        >
          <div
            v-if="fieldPhone.isFocus || fieldPhone.isVerify"
            class="field__state"
          >
            <div
              :class="verifyPhoneClass"
              class="verify"
            />
          </div>
          <div
            v-if="
              contactType === 'phone' && !!fieldPhone.value.length && fieldPhone.value.length <= 3
            "
            class="number-placeholder"
          >
            {{ fieldPhone.placeholder.slice(2) }}
          </div>
        </TextInput>
      </div>

      <div class="ads-contact-form__agreement">
        <InputCheckbox
          id="agreement"
          :value="agreement"
          @on-input="(onInput(), (agreement = $event))"
        >
          <div>
            Я прочитал(а)
            <a
              target="_blank"
              href="https://burninghut.ru/terms/"
            >
              Пользовательское соглашение</a
            >
            <span> и даю согласие на обработку своих персональных данных.</span>
          </div>
        </InputCheckbox>
      </div>

      <div class="ads-contact-form__submit">
        <button
          class="ads-contact-form__submit-button"
          :disabled="disabledForm"
          type="submit"
        >
          Отправить
        </button>
      </div>

      <div
        v-if="state === 'error'"
        class="ads-contact-form__error"
      >
        <div class="ads-contact-form__error-icon" />
        <div class="ads-contact-form__error-text">
          Сообщение не отправилось по техническим причинам. Пожалуйста, отправьте свой запрос на
          почту
          <a
            target="_blank"
            href="mailto:mironycheva@lifehacker.ru"
            >mironycheva@lifehacker.ru</a
          >
        </div>
      </div>
    </div>
  </form>
</template>

<script lang="ts">
  import TextAreaCustom from '@/components/TextArea.vue';
  import type { TFieldEdit } from '~/types/components/AdsPageContactUsForm';
  import InputRadioGroup from '@/components/InputRadio/InputRadioGroup.vue';
  import InputCheckbox from '@/components/InputCheckbox.vue';
  import TextInput from '@/components/TextInput.vue';
  import { validateEmail, validatePhoneByMask, validateName } from '~/utils/validate';
  import getSlugFromUrl from '~/utils/getSlugFromUrl';
  import { useWindowStore } from '~/store/window';

  export default defineNuxtComponent({
    name: 'AdsPageContactUsForm',

    components: {
      TextAreaCustom,
      InputRadioGroup,
      TextInput,
      InputCheckbox,
    },

    data: () => ({
      fieldName: {
        id: 'name',
        placeholder: 'Укажите реальное или вымышленное имя',
        value: '',
        propertyAPIName: 'display_name',
        ignoreTags: false,
        isFocus: false,
        isVerify: false,
        validFunc: validateName,
        state: 'pending',
      },

      fieldTarget: {
        id: 'target',
        placeholder: 'Расскажите нам о своих целях',
        maxLength: 400,
        value: '',
        propertyAPIName: 'about',
        ignoreTags: true,
        isFocus: false,
      },

      fieldEmail: {
        id: 'email',
        placeholder: 'Введите почту',
        value: '',
        propertyAPIName: 'email',
        isVerify: false,
        validFunc: validateEmail,
        state: 'pending',
        isFocus: false,
      },

      fieldPhone: {
        id: 'phone',
        placeholder: '+7 (999) 999-99-99',
        value: '',
        propertyAPIName: 'phone',
        isVerify: false,
        validFunc: validatePhoneByMask,
        state: 'pending',
        isFocus: false,
        mask: '+7 (###) ###-##-##',
      },

      contactType: 'email',
      contactTypes: [
        {
          id: 'email',
          title: 'E-mail',
        },
        {
          id: 'phone',
          title: 'Мобильный',
        },
      ],

      agreement: false,
      state: 'pending' as 'pending' | 'error' | 'success',
      isEditFormStart: false,
    }),

    computed: {
      isMobile() {
        return useWindowStore().isMobile;
      },

      disabledForm(): boolean {
        const { agreement, contactType, fieldEmail, fieldPhone, fieldName } = this;

        const validetaByContactType = {
          email: () => fieldEmail.validFunc(fieldEmail.value),
          phone: () => fieldPhone.validFunc(fieldPhone.value, fieldPhone.mask),
        } as Record<string, () => boolean>;

        const validateFields = validetaByContactType[contactType]() ?? false;
        const validateName = fieldName.validFunc(fieldName.value);

        return !agreement || !validateFields || !validateName;
      },

      verifyEmailClass(): any {
        return {
          'verify--send': !this.fieldEmail.isVerify,
          'verify--complete': this.fieldEmail.isVerify,
        };
      },

      verifyPhoneClass(): any {
        return {
          'verify--send': !this.fieldPhone.isVerify,
          'verify--complete': this.fieldPhone.isVerify,
        };
      },

      fieldNameRows(): number {
        return this.isMobile ? 2 : 1;
      },

      fieldTargetRows(): number {
        return this.isMobile ? 1 : 1;
      },

      currentSlug(): string {
        return getSlugFromUrl(this.$route.fullPath);
      },
    },

    watch: {
      'fieldEmail.value'(value) {
        this.fieldEmail.isVerify = validateEmail(value);
      },

      'fieldEmail.isVerify'(value) {
        this.fieldEmail.state = value ? 'pending' : 'error';
      },

      'fieldEmail.isFocus'(value) {
        if (!value) {
          this.fieldEmail.isVerify = validateEmail(this.fieldEmail.value);
        }
      },

      'fieldName.value'(value) {
        this.fieldName.isVerify = validateName(value);
      },

      'fieldName.isVerify'(value) {
        this.fieldName.state = value ? 'pending' : 'error';
      },

      'fieldName.isFocus'(value) {
        if (!value) {
          this.fieldName.isVerify = validateName(this.fieldName.value);
        }
      },

      'fieldPhone.value'(value) {
        this.fieldPhone.isVerify = validatePhoneByMask(value, this.fieldPhone.mask);

        if (value.length <= 2) {
          this.fieldPhone.value = this.fieldPhone.mask.slice(0, 3);
        }
      },

      'fieldPhone.isVerify'(value) {
        this.fieldPhone.state = value ? 'pending' : 'error';
      },

      'fieldPhone.isFocus'(value) {
        if (!value) {
          this.fieldPhone.isVerify = validatePhoneByMask(
            this.fieldPhone.value,
            this.fieldPhone.mask,
          );
        } else if (this.fieldPhone.value.length === 0) {
          this.fieldPhone.value = this.fieldPhone.mask.slice(0, 3);
        }
      },

      isEditFormStart() {
        this.sendAnalytics('Заполнение формы');
      },
    },

    methods: {
      parsedFieldNotTags(field: TFieldEdit): string {
        if (field.ignoreTags) {
          const regex = /(<([^>]+)>)/gi;
          const parseField = field?.value?.replace(regex, '');

          return parseField || '';
        } else {
          return field.value || '';
        }
      },

      // Функция для аналитики отправки формы
      sendAnalytics(_action: string) {},

      onFocusField(field: TFieldEdit) {
        field.isFocus = true;
      },

      onBlurField(field: TFieldEdit) {
        field.isFocus = false;
      },

      async onSubmit(event: Event): Promise<void> {
        event.preventDefault();
        this.sendAnalytics('Отправка формы');
        const form = this.$refs.form as HTMLElement;
        const formTop = window.pageYOffset + form.getBoundingClientRect().top - 48;
        this.state = 'pending';

        try {
          const {
            fieldName: { value: name },
            fieldEmail: { value: email },
            fieldPhone: { value: phone },
            fieldTarget: { value: message },
          } = this;

          const { status } = await this.$api.adsForm.send({
            name,
            message,
            phone,
            email,
          });

          if (status === 'success') {
            this.state = 'success';
            window.scrollTo(0, formTop);
          } else {
            this.state = 'error';
          }
        } catch {
          this.state = 'error';
        }
      },

      onInput(): void {
        this.isEditFormStart = true;
      },
    },
  });
</script>

<style lang="scss" scoped src="@/assets/scss/field.scss" />
<style lang="scss" scoped src="@/assets/scss/verify.scss" />
<style lang="scss">
  .ads-contact-form {
    & + br {
      content: '';
    }
  }
</style>
<style lang="scss" scoped>
  .ads-contact-form {
    background-color: #fbf8f8;
    margin-top: 32px;
    margin-left: -16px;
    margin-right: -16px;
    margin-bottom: 48px;
    padding: 32px 16px;
    border-top: 1px solid $border-color--2;
    border-bottom: 1px solid $border-color--2;

    @include tablet {
      border-left: 1px solid $border-color--2;
      border-right: 1px solid $border-color--2;
      border-radius: 32px;
      overflow: hidden;
      margin-top: 40px;
      margin-left: 0;
      margin-right: 0;
      margin-bottom: 60px;
      padding: 40px;
    }

    &__title {
      font-family: $headline-font--1;
      @include headline-small-text;
      margin-bottom: 24px;

      @include tablet {
        @include headline-medium-text;
      }
    }

    .number-input {
      position: relative;

      .number-placeholder {
        position: absolute;
        left: 38px;
        top: 30%;
        color: grey;
        font-size: 16px;
      }
    }

    &__field {
      & + & {
        margin-top: 16px;
      }

      &--name {
        :deep() {
          textarea {
            max-height: 112px;
          }

          @include tablet {
            textarea {
              height: 48px;
              max-height: 48px;
            }
          }
        }
      }

      &--target {
        :deep() {
          textarea {
            padding-bottom: 8px;
            max-height: 328px;

            @include tablet {
              max-height: 160px;
            }
          }
        }
      }
    }

    &__contact-title {
      font-family: $text-font--1;
      @include normalText;
      font-weight: 500;
      margin: 24px 0 8px;
    }

    &__contact {
      padding: 8px 0 32px;

      @include tablet {
        padding-bottom: 40px;
      }
    }

    &__radio-group {
      padding: 12px 0 12px;
    }

    &__error {
      display: grid;
      grid-template-columns: auto 1fr;
      column-gap: 8px;
      margin-top: 16px;

      @include tablet {
        margin-top: 24px;
      }

      a {
        cursor: pointer;
        display: inline-block;
        position: relative;
        text-decoration: underline;

        @include hover {
          color: #be0000;
        }
        //&::before {
        //  position: absolute;
        //  width: 100%;
        //  bottom: 0;
        //  left: 0;
        //  content: '';
        //  height: 1px;
        //  background: #ed0000;
        //}
      }

      &-icon {
        width: 24px;
        height: 24px;
        @include warningIconMask;
        background: $text-error-color--1;
      }

      &-text {
        font-family: $text-font--1;
        @include smallText;
        color: $text-error-color--1;
      }
    }

    .ads-contact-form__submit {
      margin-top: 32px;

      @include tablet {
        margin-top: 40px;
      }

      &-button {
        cursor: pointer;
        padding: 12px;
        background-color: $default-color--1;
        font-family: $text-font--1;
        @include normalText;
        font-weight: 500;
        color: $mainWhite;
        text-align: center;
        width: 100%;
        outline: none;
        border: none;
        border-radius: 24px;

        @include hover {
          background-color: $hover-color--2;
        }

        &:disabled {
          background-color: $disabled-color--1;
          cursor: default;

          @include hover {
            background-color: $disabled-color--1;
          }
        }
      }
    }

    .ads-contact-form__success {
      &-title {
        font-family: $text-font--1;
        @include mediumText;
        font-weight: 500;
        margin-bottom: 8px;

        @include tablet {
          @include normalText;
        }
      }

      &-description {
        font-family: $text-font--1;
        @include normalText;
      }
    }

    &__agreement {
      color: $text-color--2;
      :deep() a {
        @include link-styles;
      }
    }
  }
</style>
